export function truncateAddress(input: string, truncateLess = false) {
  if (!input) {
    return '';
  }
  if (input.length > 10) {
    return (
      input.substring(0, truncateLess ? 20 : 3) +
      '...' +
      input.substring(input.length - 5, input.length)
    );
  }
  return input;
}
